import type {
  CreateDeviceRepsPayload,
  DeviceRep,
  DeviceRepsRequestFilters,
  DeviceRepsResponse,
  UpdateDeviceRepPayload,
} from 'api/models/DeviceReps';
import ApiClientBase from './ApiClientBase';

class DeviceRepsEndpoint extends ApiClientBase {
  apiUri = '/api/v2/hospitals';

  getDeviceReps(params: DeviceRepsRequestFilters) {
    const _params = { ...params };
    const qs = new URLSearchParams(_params);
    return this.apiCall<DeviceRepsResponse>({ uri: '/device_reps/', data: qs });
  }

  createDeviceRep(payload: CreateDeviceRepsPayload) {
    return this.apiCall<DeviceRepsResponse>(`/device-rep/`, 'post', payload);
  }

  updateDeviceRep(deviceRepId: DeviceRep['id'], payload: UpdateDeviceRepPayload) {
    return this.apiCall(`/device-rep/${deviceRepId}/`, 'put', payload);
  }
}

const device_reps = new DeviceRepsEndpoint();
export default device_reps;
